module.exports = __webpack_public_path__ + "static/media/home1.57956095.jpg";